export enum ChallengeDelivery {
    EMAIL = 'Email',
    SMS = 'SMS',
    TOTP = 'TOTP',
    INLINE = 'Inline',
    REDIRECT = 'Redirect',
    CHOOSE_METHOD = 'ChooseMethod',
}
